// Contact details shown on the store page: only the fields the store has
// filled in, so the template can show one labelled row per field.

const FIELDS = ['phone', 'phoneInformation', 'email', 'homepage'];

/**
 * @param {object} store  store from the stores API
 * @returns {object|null} the non-empty contact fields, null when there are none
 */
export function getContact (store = {}) {
  /** @type {Record<string, string>} */
  const contact = {};
  FIELDS.forEach(field => {
    const value = typeof store[field] == 'string' ? store[field].trim() : '';
    if (value) contact[field] = value;
  });
  // The phone information is shown under the number, not without one
  if (!contact.phone) delete contact.phoneInformation;
  return Object.keys(contact).length ? contact : null;
}
